
import { AppointmentLocationMode, ServiceType } from "../../common/constants/common-basic-data";
import { GeoIPLocation } from "../../common/models/geo-ip-location.model";
import { Price } from "../../common/models/string-data.model";
import { CarJobCategory, JobStatus, JobType } from "../constants/keep-basic-data";
import { JobItem } from "./job-item.model";

export class JobModif {

  jobId = "";

  suspensive: boolean = false;
  serviceType: ServiceType = ServiceType.EXCHANGE
  jobType: JobType = JobType.INSPECTION
  itemJobTypes: JobType[] = [];

  jobCategories: CarJobCategory [] = [];

  offerId = ""
  customerId = "";
  providerId = "";
  carId = "";

  title = "";
  description = "";
  status: JobStatus = JobStatus.DRAFT;

  scheduledDate = "";
  completedDate = "";
  price: Price = Price.getDefault();

  created = "";
  lastUpdated = "";

  details: string = "";
  locationMode: AppointmentLocationMode = AppointmentLocationMode.SELLER_LOCATION;
  location: GeoIPLocation = new GeoIPLocation();
  city: string = '';
  country: string = '';
  
  appointmentDate: string = "";
  rescheduleDate: string = "";

  needCallback: boolean = false;
  emergency: boolean = false;

  jobItems: JobItem [] = [];
  appointments: string[] = [];

  constructor(){
    this.itemJobTypes = [];
    this.jobItems = []; 
    this.appointments = [];
    this.jobCategories = [];
  }
}
